import { getFileExtension } from './fileExtension'

export type PreviewKind = 'pdf' | 'image'

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif']

/**
 * How a portal file can be shown in the in-app preview, judged by its name, or
 * undefined when it can only be downloaded. The stored Content-Type can't be
 * trusted for this: uploads keep whatever type the uploader's browser reported.
 */
export function getPreviewKind(fileName: string | undefined | null): PreviewKind | undefined {
  const extension = getFileExtension(fileName)
  if (extension === 'pdf') return 'pdf'
  if (extension && IMAGE_EXTENSIONS.includes(extension)) return 'image'
  return undefined
}
